export class LoadFormat {
  static readonly type = '[Format] Load Format';

  constructor(readonly slug: string) {}
}
